import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import { RootStoreContext } from "../app/stores/rootStore";
import PodiumNavbar from "../components/podium/PodiumNavbar";
import SpeakerBrowsePage from "../components/podium/SpeakerBrowsePage";
import NotFoundPage from "./NotFoundPage";

interface IPodiumSpeakerParams {
  tenant: string;
  meetingId: string;
  speakerId: string;
}

const PodiumSpeakerPage: React.FC<
  RouteComponentProps<IPodiumSpeakerParams>
> = () => {
  const rootStore = useContext(RootStoreContext);
  const { currentTenant } = rootStore.tenantStore;
  const { user } = rootStore.userStore;

  return (
    <>
      <PodiumNavbar currentTenant={currentTenant!} user={user!} />
      <Switch>
        <Route
          exact
          path="/:tenant/meeting/:meetingId/podium/:speakerId"
          component={SpeakerBrowsePage}
        />
        <Route component={NotFoundPage} />
      </Switch>
    </>
  );
};

export default observer(PodiumSpeakerPage);
